import type { ComponentProps } from '@enonic/react-components'
import type { RichTextData } from '@enonic/react-components'
import * as React from 'react'
import { Prose, Section, Container } from '../primitives'

interface KeyInfoItem {
  heading: string
  body?: RichTextData
}

export interface KeyInfoData extends Record<string, unknown> {
  heading?: string
  items: KeyInfoItem[]
}

export const KeyInfo = (props: ComponentProps) => {
  const { heading, items } = props.data as KeyInfoData

  if (!items || items.length === 0) return null

  return (
    <Section>
      <Container>
        {heading && (
          <h2 className="col-span-full text-3xl text-blue-900 md:text-6xl mb-8 md:mb-12">
            {heading}
          </h2>
        )}
        {items.map((item, index) => (
          <article
            key={index}
            className="col-span-6 md:col-span-4 grid grid-rows-subgrid row-span-3"
          >
            <h3 className="text-xl md:text-2xl font-bold text-blue-900">{item.heading}</h3>
            <hr className="border-peach-500 py-2" />
            {item.body && (
              <Prose
                data={item.body}
                meta={props.meta}
                common={props.common}
                component={props.component}
              />
            )}
          </article>
        ))}
      </Container>
    </Section>
  )
}
